import { IState } from '../../store';
import { IMediaItem } from '../../types/newbuildingTiledCarousel';
import { mapOfferDataToNewbuildingGallery } from '../../utils/newbuildingTiledCarousel/mapOfferDataToNewbuildingGallery';
import { mapOfferDataToNewbuildingGalleryVideo } from '../../utils/newbuildingTiledCarousel/mapOfferDataToNewbuildingGalleryVideo';
import { getFloorPlan } from './getFloorPlan';
import { getLayout } from './getLayout';
import { getPhotos } from './getPhotos';
import { getVideos } from './getVideos';

export const getNewbuildingTiledCarouselPhotos = (state: IState): IMediaItem[] => {
  const layout = getLayout(state);
  const floorPlan = getFloorPlan(state);
  const photos = getPhotos(state);
  const videos = getVideos(state);
  const mappedPhotos = mapOfferDataToNewbuildingGallery(photos);
  let newbuildingTiledCarouselPhotos = [...mappedPhotos];

  if (floorPlan) {
    const mappedPlan = mapOfferDataToNewbuildingGallery([floorPlan]);
    newbuildingTiledCarouselPhotos = [...mappedPlan, ...newbuildingTiledCarouselPhotos];
  }

  if (layout) {
    const mappedLayout = mapOfferDataToNewbuildingGallery([layout]);
    newbuildingTiledCarouselPhotos = [...mappedLayout, ...newbuildingTiledCarouselPhotos];
  }

  if (videos.length) {
    const mappedVideos = mapOfferDataToNewbuildingGalleryVideo(videos);
    newbuildingTiledCarouselPhotos = [...newbuildingTiledCarouselPhotos, ...mappedVideos];
  }

  return newbuildingTiledCarouselPhotos;
};
